
export const ModalActionTypes = {
  SHOW_LOGIN: "SHOW_LOGIN",
  HIDE_LOGIN: "HIDE_LOGIN",
  SHOW_SIGNUP: "SHOW_SIGNUP",
  HIDE_SIGNUP: "HIDE_SIGNUP"
}